import {AfterViewChecked, ChangeDetectorRef, Component, OnInit, ViewChild, TemplateRef} from '@angular/core';
import {ApiService} from '../../services/api.service';
import {AuthenticationService} from "../../services/authentication.service";
import {HttpParams} from '@angular/common/http';
import * as _ from 'lodash';
import * as moment from 'moment';
import {SelectItem} from "primeng/api";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {CALENDAR_LOCALE} from '../../services/constant';
import {TemplateService} from "../../services/template.service";
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import index from "@angular/cli/lib/cli";
import {dataUrl} from "angular-file/file-upload/fileTools";

@Component({
  selector: 'app-tax-report',
  templateUrl: './tax-report.component.html',
  styleUrls: ['./tax-report.component.scss'],
  providers: [TemplateService]
})
export class TaxReportComponent implements OnInit, AfterViewChecked {
  itemsPerPage = 40;

  calendarLocale;
  selectedCustomercode: SelectItem[];
  customercode: any;
  selectedHomeproGroup: SelectItem[];
  homeproGroup: any;
  startDate: Date;
  endDate: Date;
  minDate: Date;
  maxDate: Date;
  allDeliverycode = true;
  allDocType = true;
  notApprove: any;
  deliverycode: any;
  selectedDeliverycode: SelectItem[];
  deliverycodeSuggest: any;
  typeSuggest: any;
  documentType: any;
  allDocumentType = [];
  allDeliverycodeSelected = [];
  tableData: any;
  modal: NgbModalRef;
  loding_modal: NgbModalRef
  currentPage = 1;
  totalItems: number;
  loading = false;
  no_data = true;
  errorMsg = '';
  modalData: any;
  loadingExcel = false;
  loadingAllExcel = false;
  cofirm_loading = false;
  deliverycodeList: any = null;
  allDeliverycodeList: any = null;
  selectedValues = [];
  docTypeList: any = null;
  rdDocumentType: any;
  selectedRdDocumentType: any;
  customercode_all: any;
  defaultLabel = null;
  mergecheckbox: any;
  checkAll = false;
  loadingAll= false;
  tableDataAll: any;
  no_dataAll= true;

  tableArray = [];
  allZipCount: number;
  cancel_loading_all_zip = false;
  loading_all_zip = false;
  keepexcel = [];

  sortBy: string;
  sortMode: string;

  tableCol = [];
  is_TH = false;

  @ViewChild('content') content: any;
  @ViewChild('tt') table: any;
  @ViewChild("modalTemplate") modalTemplate: TemplateRef<any>;

  constructor(private apiService: ApiService,
              private modalService: NgbModal,
              private cdr: ChangeDetectorRef,
              private authService: AuthenticationService,
              private template: TemplateService,
              private translate: TranslateService) {
  }

  // ngOnInit() {
  //   this.loadTexts();
  //   this.pageChanged();
  //   this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
  //     if (event.lang === 'th') {
  //       this.is_TH = true;
  //     }
  //     if (event.lang === 'en') {
  //       this.is_TH = false;
  //     }
  //     this.loadTexts();
  //   });
  // }

  ngOnInit() {
    // this.loadDropdown();
    //   this.searchData();
    // this.loadInput();
    // this.loadTexts();
    // this.pageChanged()
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadTexts();
    });
    this.loadTexts();
    this.rdDocumentType = this.template.getDropdown();
    this.rdDocumentType.splice(0, 0, {label: this.translate.instant('COMMON.ALL'), value: null});
  }

  loadTexts() {
    this.tableCol = [];
    // this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
    //   if (event.lang === 'en') {
    //     this.calendarLocale = CALENDAR_LOCALE.EN;
    //   } else {
    //     this.calendarLocale = CALENDAR_LOCALE.TH;
    //   }
    // });
    this.defaultLabel = this.translate.instant('COMMON.ALL');
    if (this.translate.currentLang === 'en') {
      this.calendarLocale = CALENDAR_LOCALE.EN;
    } else {
      this.calendarLocale = CALENDAR_LOCALE.TH;
    }
    this.translate.get('FILTER.DATE').subscribe((res: string) => {
      this.tableCol.push(
        {field: 'customer_code', header: this.translate.instant('FILTER.CUSTOMER-CODE')},
        {field: 'delivery_code', header: this.translate.instant('FILTER.DELIVERY-CODE')},
        {field: 'date', header: res},
        // { field: 'group', header: 'Business' },
        {field: 'branch', header: this.translate.instant('TABLE.BRANCH-NAME')},
        {field: 'rd_doc_type', header: this.translate.instant('FILTER.DOCUMENT-TYPE')},
        // { field: 'doc_type', header: 'ประเภทเอกสารในองค์กร' },
        {field: 'start_end_document', header: this.translate.instant('TABLE.DOCUMENT-NUMBER-START-END')},
        {field: 'total_doc', header: this.translate.instant('TABLE.NUMBER-DOCUMENTS')},
        {field: 'total_missing_doc', header: this.translate.instant('TABLE.NUMBER-MISSING-DOCUMENTS')},
        {field: 'non_vat', header: this.translate.instant('TABLE.SALES') + ' Non-VAT'},
        {field: 'vat', header: 'VAT'},
        {field: 'total_payment', header: this.translate.instant('TABLE.SALES') + ' VAT'});
      let documentData = this.template.getDropdown();
      documentData.splice(0, 0, {label: this.translate.instant('COMMON.ALL'), value: null});
      this.rdDocumentType = documentData;
      this.tableCol = _.uniqBy(this.tableCol, 'field');
      this.loadInput();
    });
  }

  get yearRange() {
    const thisYear = (new Date()).getFullYear();
    return (2020) + ':' + (thisYear);
  }

  get dateRange() {
    const start = moment(this.startDate).format('DD/MM/YYYY');
    const end = moment(this.endDate).format('DD/MM/YYYY');
    return start + ' - ' + end;
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  loadInput() {
    this.customercode = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];
    let params = new HttpParams();
    params = params.append('none_pagination', 'true')
    this.apiService.getCustomerList(params).subscribe(
      (result) => {
        _.forEach(result, (obj) => {
          this.customercode.push({
            label: obj.c_code,
            value: obj.id
          });
        });
        this.customercode = _.uniqBy(this.customercode, 'label');
      },
      error => {
        console.log('error', error);
      }
    );

    this.homeproGroup = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    this.apiService.getCompanyGroup().subscribe(
      (result) => {
        _.forEach(result, (obj) => {
          this.homeproGroup.push({
            label: obj.name,
            value: obj.id
          })
        });
      }
    );

    this.apiService.getDeliveryList().subscribe(
      (result) => {
        this.allDeliverycodeList = result;
        this.filterDeliverycodeList();
      }
    );

    this.startDate = new Date();
    this.startDate.setFullYear(new Date().getFullYear(), 0, 1);
    this.endDate = new Date();
    this.selectedCustomercode = null;
    this.selectedRdDocumentType = null;
  }

  filterDeliverycodeList() {
    this.selectedDeliverycode = null;

    this.deliverycodeList = [{
      label: this.translate.instant('COMMON.ALL'),
      value: null
    }];

    _.forEach(this.allDeliverycodeList, (obj) => {
      if (this.selectedCustomercode == null || obj.d_custcode == this.selectedCustomercode)
        this.deliverycodeList.push({
          label: obj.d_code,
          value: obj.id
        })
    });
  }

  pageChanged() {
    const params = new HttpParams().set('page', _.toString(this.currentPage));
    this.deselectAll();
    this.checkAll = false;
    this.searchData(params);
  }


  searchButtonClicked() {
    this.currentPage = 1;
    this.sortBy = null;
    this.sortMode = null;
    if (!this.no_data) {
      this.table.reset();
    }
    this.searchData();
  }

  setMinDate() {
    this.minDate = this.startDate;
    if (this.endDate < this.minDate) {
      this.endDate = this.minDate;
    }
  }

  setMaxDate() {
    this.maxDate = this.endDate;
    if (this.startDate > this.maxDate) {
      this.startDate = this.maxDate;
    }
  }

  canUserApproveDoc() {
    return this.authService.isAccountant() || this.authService.isUIH();
  }

  searchDeliverycode(event) {
    if (this.deliverycodeList == null) {
      this.apiService.getDeliveryList().subscribe(
        (data) => {
          this.deliverycodeList = data;
          this.deliverycodeSuggest = this.filterData(event.query, 'd_code', this.deliverycodeList);
        }
      );
    } else {
      this.deliverycodeSuggest = this.filterData(event.query, 'd_code', this.deliverycodeList);
    }
  }

  searchDocumentType(event) {
    if (this.docTypeList == null) {
      this.apiService.getDocumentType().subscribe(
        (result) => {
          this.docTypeList = result;
          this.typeSuggest = this.filterData(event.query, 'type', this.docTypeList);
        }
      );
    } else {
      this.typeSuggest = this.filterData(event.query, 'type', this.docTypeList);
    }
  }

  filterData(query, field, dataList) {
    query = query.toLowerCase().trim()

    const filtered: any[] = [];
    for (let i = 0; i < dataList.length; i++) {
      let data = dataList[i];
      if (data[field].toLowerCase().indexOf(query) >= 0) {
        filtered.push(data);
      }
    }
    return filtered;
  }

  selectAllDeliverycode() {
    this.deliverycode = null;
  }

  selectDocType() {
    this.documentType = null;
  }

  searchData(params?) {
    this.loading = true;
    this.checkCondition();

    if (this.errorMsg.length > 0) {
      this.loading = false;
      return;
    }

    this.allDeliverycodeSelected = [];
    this.allDocumentType = [];
    _.forEach(this.deliverycode, (data) => {
      // this.allDeliverycodeSelected = [];
      this.allDeliverycodeSelected.push(_.toNumber(data.id))
    });
    _.forEach(this.documentType, (data) => {
      // this.allDocumentType = [];
      this.allDocumentType.push(_.toNumber(data.id))
    });

    const data = {
      not_approved_only: this.notApprove,
      header_issue_date_start: moment(this.startDate).format('YYYY-MM-DD'),
      header_issue_date_end: moment(this.endDate).format('YYYY-MM-DD'),
      corporate_group_id: this.selectedHomeproGroup,
      customercode_id: this.selectedCustomercode,
      document_type_id: (_.isNil(this.documentType)) ? this.documentType : _.uniq(this.allDocumentType),
      deliverycode_id: this.selectedDeliverycode ? this.selectedDeliverycode : null,
      items_per_page: this.itemsPerPage,
      rd_doc_type: this.selectedRdDocumentType
    };

    if (this.sortBy && this.sortMode) {
      data['sort'] = this.sortBy;
      data['sort_type'] = this.sortMode;
    }

    if (this.currentPage === 1) {
      params = null
    }

    this.apiService.postSaleTax(data, params).subscribe(
      (result) => {
        this.loading = false;
        this.tableData = result.results;
        this.no_data = _.isEmpty(this.tableData);
        this.totalItems = result.count;
      },
      error => {
        this.loading = false;
        this.no_data = true;
        this.errorMsg = this.translate.instant('ERROR.TRY-AGAIN');
      }
    )
  }

  confirmDocument(event, content, index) {
    // event.currentTarget.blur();
    document.getElementById('chkbox' + index).blur();
    event.preventDefault();

    this.modalData = this.tableData[index];
    this.modal = this.modalService.open(content, {backdrop: 'static', keyboard: false});
  }

  confirm() {
    this.cofirm_loading = true;

    let params = {
      approved: this.modalData.approved,
      header_issue_date: this.modalData.header_issue_date,
      group: this.modalData.group,
      document_type: this.modalData.document_type,
      rd_document_type: this.modalData.rd_document_type,
      corporate_branch: this.modalData.corporate_branch,
    };

    this.apiService.approveSale(params).subscribe(
      (result) => {
        this.cofirm_loading = false;
        this.modal.close();
        this.modal = null;
      },
      error => {
        this.cofirm_loading = false;
      }
    );
  }

  revertBack() {
    this.modalData.approved = !this.modalData.approved;
    this.modal.close();
    this.modal = null;
  }

  clearData() {
    this.tableData = undefined;
    this.no_data = true;
    this.startDate = new Date();
    this.startDate.setFullYear(new Date().getFullYear(), 0, 1);
    this.endDate = new Date();
    this.selectedCustomercode = null;
    this.selectedDeliverycode = null;
    this.selectedRdDocumentType = null;
    this.deliverycode = null;
    this.documentType = null;
    this.notApprove = false;
    this.allDocType = true;
    this.allDeliverycode = true;
    this.sortBy = null;
    this.sortMode = null;
    this.selectedValues = [];
    this.keepexcel = [];


    this.searchButtonClicked();
  }

  getExportDocs(data, index) {
    this.tableData[index].loading_all_docs_excel = true;

    const params = {
      header_issue_dt: data.header_issue_date,
      document_type: data.document_type,
      rd_document_type: data.rd_document_type,
      corporate_branch: data.corporate_branch,
      group: data.group,
      delivery_code: data.delivery_code,
      customer_code: data.customer_code,
      lang: this.translate.currentLang
    };
    this.apiService.getAllDocs(params).subscribe(
      (obj) => {
        this.tableData[index].loading_all_docs_excel = false;
        let filename = 'daily_report ' + params.header_issue_dt + '.xlsx';
        this.apiService.createDownloadFile(obj, filename);
        this.apiService.triggerLog({
            'log_type': 'DOWNLOAD_EXCEL',
          'action_issue': 'SALE_TAX_REPORT',
          'description': `${data.rd_document_type} cc: ${data.customer_code} dc: ${data.delivery_code} date: ${data.header_issue_date} `
        }).subscribe();
        // data.xmlLoading = false;
      },
      error => {
        this.tableData[index].loading_all_docs_excel = false;
        // data.xmlLoading = false;
      }
    )
  }

  async fetchAllData() {
    const data = {
      not_approved_only: this.notApprove,
      header_issue_date_start: moment(this.startDate).format('YYYY-MM-DD'),
      header_issue_date_end: moment(this.endDate).format('YYYY-MM-DD'),
      corporate_group_id: this.selectedHomeproGroup,
      customercode_id: this.selectedCustomercode,
      document_type_id: (_.isNil(this.documentType)) ? this.documentType : _.uniq(this.allDocumentType),
      deliverycode_id: this.selectedDeliverycode ? this.selectedDeliverycode : null,
      items_per_page: this.totalItems,
      rd_doc_type: this.selectedRdDocumentType
    };

    if (this.sortBy && this.sortMode) {
      data['sort'] = this.sortBy;
      data['sort_type'] = this.sortMode;
    }

    return new Promise((resolve, reject) => {
      this.apiService.postSaleTax(data).subscribe(
        (result) => {
          this.loadingAll = false;
          this.tableDataAll = result.results;
          this.no_dataAll = _.isEmpty(this.tableDataAll);
          resolve(result.results);
        },
        error => {
          this.loadingAll = false;
          this.no_dataAll = true;
          this.errorMsg = this.translate.instant('ERROR.TRY-AGAIN');
          reject(error);
        }
      )
    })
  }
  async downloadAll() {
    await this.fetchAllData();
    this.keepexcel = []
    for (let i = 0; i < this.tableDataAll.length; i++) {
      this.keepexcel.push({
        'header_issue_date': this.tableDataAll[i].header_issue_date,
        'document_type': this.tableDataAll[i].document_type,
        'rd_document_type': this.tableDataAll[i].rd_document_type,
        'corporate_branch': this.tableDataAll[i].corporate_branch,
        'group': this.tableDataAll[i].group,
        'delivery_code': this.tableDataAll[i].delivery_code,
        'customer_code': this.tableDataAll[i].customer_code
      });
    }
    this.downloadMerge();
  }

  openLoadingModal(): void {
    this.loding_modal = this.modalService.open(this.modalTemplate, {
      backdrop: 'static',
      size: "lg",
      centered: true,
    });
  }

  closeLoadingModal(): void {
    this.loding_modal.close();
  }

  downloadMerge() {
    this.openLoadingModal();
    let excelData = [];
    this.keepexcel.forEach(data => {
      excelData.push({
        'header_issue_dt': data.header_issue_date,
        'document_type': data.document_type,
        'rd_document_type': data.rd_document_type,
        'corporate_branch': data.corporate_branch,
        'group': data.group,
        'delivery_code': data.delivery_code,
        'customer_code': data.customer_code
      });
    });

    const params = {
      lang: this.translate.currentLang,
      merged_data_list: excelData
    };
    this.apiService.getMergeExcel(params).subscribe(
      (obj) => {
        let filename = 'merge_daily_report '  + '.xlsx';
        this.apiService.createDownloadFile(obj, filename);
        params.merged_data_list.forEach(data => {
          this.apiService.triggerLog({
            'log_type': 'DOWNLOAD_EXCEL',
            'action_issue': 'SALE_TAX_REPORT',
            'description': `${data.rd_document_type} cc: ${data.customer_code} dc: ${data.delivery_code} date: ${data.header_issue_dt} `
          }).subscribe();
        });
        this.closeLoadingModal();
      },
      error => {
        this.closeLoadingModal(); // Close loading modal on error too
      }
    );
  }

  downloadMissingDocs(data, index) {
    this.tableData[index].loading_missing_excel = true;
    // data.xmlLoading = true;
    const params = {
      header_issue_dt: data.header_issue_date,
      document_type: data.document_type,
      rd_document_type: data.rd_document_type,
      corporate_branch: data.corporate_branch,
      max_document: data.max_document,
      min_document: data.min_document,
      group: data.group,
      delivery_code: data.delivery_code,
      customer_code: data.customer_code,
      lang: this.translate.currentLang
    };
    this.apiService.getMissingDoc(params).subscribe(
      (obj) => {
        this.tableData[index].loading_missing_excel = false;
        let filename = 'daily_missing ' + params.header_issue_dt + '.xlsx';
        this.apiService.createDownloadFile(obj, filename);
        // this.apiService.triggerLog({'log_type': 'DOWNLOAD_EXCEL'}).subscribe(); // TODO: get missing doc download logs
        // data.xmlLoading = false;
      },
      error => {
        this.tableData[index].loading_missing_excel = false;
        // data.xmlLoading = false;
      }
    );
  }

  clearDeliverycode() {
    this.allDeliverycodeSelected = [];
  }

  clearDocType() {
    this.allDocumentType = [];
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  checkCondition() {
    this.errorMsg = '';

    let errorMsgList = [];
    if (_.isEmpty(this.deliverycode) && this.allDeliverycode === false) {
      errorMsgList.push(this.translate.instant('FILTER.DELIVERY-CODE'));
    }

    if (_.isEmpty(this.documentType) && this.allDocType === false) {
      errorMsgList.push('Doc Type');
    }

    if (errorMsgList.length > 0) {
      this.errorMsg = this.translate.instant('COMMON.SPECIFY') + ' ' + errorMsgList.join(', ') + ' ' + this.translate.instant('COMMON.CORRECT');
      return;
    }

    // let dayDiff = Math.abs(moment(this.endDate).diff(moment(this.startDate), 'days'));
    // if (dayDiff > 60 && this.authService.isAccountant()) {
    //   this.errorMsg = "ไม่สามารถเลือกระยะเวลาเกิน 60 วัน";
    // }
  }

  sort(event) {
    this.sortBy = event.field;
    if (event.order === 1) {
      this.sortMode = 'asc';
    } else {
      this.sortMode = 'desc';
    }

    // this.searchData();
  }

  selectDeselectAll(checked) {
    if (checked) {
      this.selectAll();
      this.checkAll = true;
      return;
    }
    this.deselectAll();
    this.checkAll = false;
  }

  selectAll() {
    this.keepexcel = []
    for (let i = 0; i < this.tableData.length; i++) {
      this.selectedValues[i] = true;
      this.keepexcel.push({
        'header_issue_date': this.tableData[i].header_issue_date,
        'document_type': this.tableData[i].document_type,
        'rd_document_type': this.tableData[i].rd_document_type,
        'corporate_branch': this.tableData[i].corporate_branch,
        'group': this.tableData[i].group,
        'delivery_code': this.tableData[i].delivery_code,
        'customer_code': this.tableData[i].customer_code
      });
    }
  }

  deselectAll() {
    for (let i = 0; i <= this.tableData.length; i++) {
      this.selectedValues[i] = false;

    }
    this.keepexcel = []
  }

  downloadCheckbox() {
    this.keepexcel = []
    for (let i = 0; i < this.selectedValues.length; i++) {
      if (!this.selectedValues[i])
        continue;

      this.keepexcel.push(this.tableData[i]);

    }
    if (!_.isEmpty(this.keepexcel)) {

    }

  }


  EnabledDownloadSelected() {
    return this.selectedValues.filter(select => select == true).length > 0
  }
}






// WEBPACK FOOTER //
// /opt/app/src/app/features/tax-report/tax-report.component.ts